import { setUserToken, setUserInfo, resetUser } from "./user";
import { reqLogin } from "@/api/login";
import { saveToken, saveUser, clearLocalDatas, USER_INFO, TOKEN } from "@/utils/auth";
import { decodeToken } from "@/utils/tokenManager";

// 登录action
export const login = (data) => (dispatch) => {
  return new Promise((resolve, reject) => {
    reqLogin(data)
      .then((response) => {
        if (response.status === 0) {
          const token = response.token;
          const needPassword = response.needPassword;

          // 从 token 中提取 role 信息
          const payload = decodeToken(token);
          const role = payload ? payload.role : "";

          const userData = { ...response.data, role, needPassword };

          // 保存token到localStorage
          saveToken(token);

          // 保存用户信息到localStorage
          saveUser(JSON.stringify(userData));

          // 更新Redux状态
          dispatch(setUserToken(token));
          dispatch(setUserInfo(userData));

          resolve(response);
        } else {
          const msg = response.message || "登录失败";
          reject(msg);
        }
      })
      .catch((error) => {
        reject(error);
      });
  });
};

// 登出action
export const logout = () => (dispatch) => {
  // 重置用户状态
  dispatch(resetUser());

  // 清除本地存储
  clearLocalDatas([USER_INFO, TOKEN]);

  return {
    status: 0,
    data: "success",
  };
};
